// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"321":"df879722","453":"50378c0d","850":"317d913e"}[chunkId] + ".chunk.js";
};